export default class OrganizationFields {

  static readonly administrators = "field_administrators"
  static readonly altPhone = "field_alt_phone"
  static readonly description = "field_description"
  static readonly displayTitle = "field_display_title"
  static readonly email = "field_email"
  static readonly feedback = "field_feedback"
  static readonly firstName = "field_first_name"
  static readonly hasLocation = "field_has_location"
  static readonly importId = "field_import_id"
  static readonly lastName = "field_last_name"
  static readonly legalName = "field_legal_name"
  static readonly logo = "field_logo"
  static readonly mentorCityEnabled = "field_mentor_city_enabled"
  static readonly mtg = "field_mtg"
  static readonly mtgEnabled = "field_mtg_enabled"
  static readonly phone = "field_phone"
  static readonly physicalLocation = "field_physical_location"
  static readonly position = "field_position"
  static readonly positionOther = "field_position_other"
  static readonly ready = "field_ready"
  static readonly session = "field_session"
  static readonly standing = "field_standing"
  static readonly taxStatus = "field_tax_status"
  static readonly taxStatusOther = "field_tax_status_other"
  static readonly type = "field_type"
  static readonly typeOther = "field_type_other"
  static readonly webAddress = "field_web_address"

}